module.exports = __webpack_public_path__ + "static/media/number2.40899b71.svg";